import React, { Component } from 'react';

export default class PageNotFound extends Component {

    render() {
        return (
            <div>
                <img src="/static/images/pectem_shell.png" className="pectem" alt="Shell" />
                <div className="container">
                    <div className="row">
                        <div className="col s12 m6 offset-m3">
                            <img src="/static/images/errors/404-icon.png" className="responsive-img" alt="Pagina no encontrada" />
                            <p className="text-center error-no">
                                <span>ERROR 404</span>
                            </p>
                        </div>
                        <div className="col s12 m6 offset-m3 margin-top-50">
                            <p className="text-center error-text">
                                No podemos encontrar lo que estás buscando.<br />
                                Puede que el enlace esté dañado o haya expirado. ¡Lo sentimos!
                            </p>
                        </div>
                        <div className="col s12 m6 offset-m3 margin-top-50">
                            <p className="text-center error-text">
                                <a href="/">Inicio</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PageNotFound/pageNotFound.js